// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.viewer-office[data-v-7e29d1d4] {\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n  background: #f5f6fa;\n}\n", ""]);
// Exports
module.exports = exports;
